module.exports = __webpack_public_path__ + "static/fonts/NotoSansKR-Bold-Hestia.72dd74d.otf";